import { Instance } from 'mobx-state-tree';
import model from './model';

const AlphaSenseSensor = model;

export interface IAlphaSenseSensor extends Instance<typeof AlphaSenseSensor> {}

export default AlphaSenseSensor;
